import { defineStore } from "pinia";
import { showError } from "src/utils/notify";

export const useLottery = defineStore("lottery", {
  state: () => ({
    lotteryList: [],
    loadlottery: false,
  }),
  getters: {},
  actions: {
    resetLotteryData() {
      this.lotteryList = [];
      this.loadlottery = false;
    },
    async getLotteryPurchaseData(params) {
      try {
        if (params.page == 1) {
          this.lotteryList = [];
          this.loadlottery = false;
        }
        let response = await this.$request.post(this.apiEndpoints.LOTTERY, {
          page: params.page,
          per_page: params.per_page,
        });
        if (response.data) {
          Array.prototype.push.apply(this.lotteryList, response.data.items);
          this.loadlottery = true;
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async setLotteryStatus(params) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.SET_LOTTERY_STATUS,
          params
        );
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {}
    },
  },
});
